<template>
  <v-dialog v-model="dialog" ref="dialog" persistent max-width="600px">
    <ValidationObserver
      v-slot="{ invalid }"
      slim
      ref="validationObserverDialog"
    >
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("projects.annotationClasses.add.title") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <p>
                {{ $t("projects.annotationClasses.add.subtitle") }}
              </p>
            </v-row>
            <v-row>
              <ValidationProvider rules="required" v-slot="{ errors }" slim>
                <v-text-field
                  :label="$t('projects.annotationClasses.add.classnameLabel')"
                  v-model="model.class_name"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-row>
            <v-row>
              <ValidationProvider rules="required" v-slot="{ errors }" slim>
                <v-select
                  :disabled="editMode"
                  :items="geometries"
                  :label="$t('projects.annotationClasses.add.annotationGeometryLabel')"
                  item-text="text"
                  item-value="id"
                  v-model="model.annotation_geometry"
                  :error-messages="errors"
                ></v-select>
              </ValidationProvider>
            </v-row>
            <v-row class="flex-column">
              <h3 class="text-body-1">
                {{ $t("projects.annotationClasses.add.strokeColor") }}
              </h3>
              <div class="d-flex">
                <v-swatches
                  v-model="model.color"
                  show-fallback
                  fallback-input-type="color"
                  popover-x="right"
                ></v-swatches>
              </div>
            </v-row>
            <v-row class="flex-column mt-5">
              <h3 class="text-body-1">
                {{ $t("projects.annotationClasses.add.fillColor") }}
              </h3>
              <div class="d-flex">
                <v-swatches
                  v-model="model.fill_color"
                  show-fallback
                  fallback-input-type="color"
                  popover-x="right"
                ></v-swatches>
              </div>
            </v-row>
            <v-row>
              <ValidationProvider rules="required" v-slot="{ errors }" slim>
                <v-textarea
                  :error-messages="errors"
                  :label="$t('projects.annotationClasses.add.description')"
                  v-model="model.description"
                ></v-textarea>
              </ValidationProvider>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('hide')"
            :disabled="loading"
          >
            {{ $t("button.cancel") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="onClickDialogSave"
            :disabled="invalid"
            :loading="loading"
          >
            {{ $t("button.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import VSwatches from "vue-swatches";
import { mapState } from "vuex";
import { PERSIST } from "@/store/modules/annotationClass";

export default {
  props: {
    show: Boolean,
    value: Object
  },
  data() {
    return {
      dialog: false,
      model: {},
    };
  },
  computed: {
    ...mapState({ loading: state => state.annotationClass.loading }),
    editMode() {
      return this.model.id !== undefined;
    },
    geometries() {
      return [
        {
          id: "Circle",
          text: this.$t("projects.annotationClasses.classes.circle")
        },
        {
          id: "Polygon",
          text: this.$t("projects.annotationClasses.classes.polygon")
        },
        {
          id: "LineString",
          text: this.$t("projects.annotationClasses.classes.line")
        },
        {
          id: "Point",
          text: this.$t("projects.annotationClasses.classes.point")
        },
        {
          id: "Square",
          text: this.$t("projects.annotationClasses.classes.square")
        }
      ]
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    },
    value: {
      immediate: true,
      handler(val) {
        this.model = Object.assign({}, val);
      }
    }
  },
  methods: {
    reset() {
      if (!this.editMode) {
        this.model = {
          fill_color: "#90ee90",
          color: "#ff0000",
          numberOfAnnotations: 0,
          annotation_geometry: "Polygon"
        };
      }
    },
    async onClickDialogSave() {
      await this.$store.dispatch(PERSIST, this.model);
      // reset dialog
      this.reset();
      this.$notify({
        text: "Action completed.",
        type: "success"
      });
      this.$emit("hide");
    }
  },
  mounted() {
    this.reset();
  },
  components: {
    VSwatches
  }
};
</script>

<style scoped></style>
